/** @format — Shown in tracking chat when code cannot be resolved */

import React from "react";
import { SearchX } from "lucide-react";

export default function TrackingNotFoundCard({ props = {} }) {
  const code = props.trackingCode ?? props.code ?? "";
  const message =
    props.message ??
    "We couldn't find a shipment for this tracking number. Check the ID or BOL and try again.";

  return (
    <div
      className="flex flex-col gap-3 p-4 w-full rounded-lg border border-[#e4e7ec] bg-white"
      style={{ boxShadow: "0px 1px 4px 0 rgba(12,12,13,0.05)" }}
    >
      <div className="flex gap-3 items-start">
        <div className="flex flex-shrink-0 justify-center items-center w-10 h-10 rounded-lg bg-neutral-100">
          <SearchX className="w-5 h-5 text-[#475367]" aria-hidden />
        </div>
        <div className="flex flex-col flex-1 gap-1 min-w-0">
          <p className="text-sm font-semibold text-[#1d2739]">Shipment not found</p>
          {code ? (
            <p className="text-xs text-[#667185]">
              No match for <span className="font-medium text-[#1d2739]">#{String(code).replace(/^#/, "")}</span>
            </p>
          ) : null}
          <p className="text-sm text-[#667185] leading-relaxed">{message}</p>
        </div>
      </div>
      <p className="text-xs text-[#98A2B3] pl-[52px]">
        Dockie tracks ocean shipments using a valid booking ID, BOL, or tracking number tied to your
        account.
      </p>
    </div>
  );
}
